import { render, staticRenderFns } from "./tab-computer-skills.vue?vue&type=template&id=e3f40e22"
import script from "./tab-computer-skills.vue?vue&type=script&lang=js"
export * from "./tab-computer-skills.vue?vue&type=script&lang=js"
import style0 from "./tab-computer-skills.vue?vue&type=style&index=0&id=e3f40e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports